export const fallbackScales = [
  "Fibonacci sequence",
  "Fibonacci sequence (modified)",
  "T-shirt sizing",
  "Custom",
];

/**
 * Маппинг label → ключ
 */
export const mapScaleToKey = (label: string): string => {
  switch (label) {
    case "Fibonacci sequence":
      return "fibonacci";
    case "Fibonacci sequence (modified)":
      return "fibonacciModified";
    case "T-shirt sizing":
      return "tshirt";
    case "Custom":
      return "custom";
    default:
      return "fibonacci";
  }
};

/**
 * Наборы стандартных шкал (для расчётов и UI)
 */
export const scaleValues: Record<string, string[]> = {
  fibonacci: ["1", "2", "3", "5", "8", "13", "21", "34", "55", "?"],
  fibonacciModified: ["0.5", "1", "2", "3", "5", "8", "13", "20", "40", "100", "?"],
  tshirt: ["XS", "S", "M", "L", "XL", "?"],
};

/**
 * Получает массив значений шкалы для расчётов.
 * - Если передана кастомная шкала (из Firestore) → возвращает её
 * - Иначе — стандартную по ключу
 * - Если ключ неизвестен → возвращает шкалу Fibonacci как fallback
 */
export function getScaleValues(
  estimationType: string,
  customValues?: string[]
): string[] {
  if (estimationType === "custom") {
    return customValues && customValues.length > 0 ? customValues : ["1", "2", "3", "?"];
  }

  const base = scaleValues[estimationType];
  if (base && base.length > 0) {
    return base;
  }

  return scaleValues.fibonacci;
}

/**
 * Утилита: проверяет, является ли шкала числовой
 * (используется для решения, считать ли среднее/разброс)
 */
export function isNumericScale(scale: (number | string)[]): boolean {
  return scale.every((v) => typeof v === "number" || !Number.isNaN(Number(v)));
}
